var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
        attrs: {
          "element-loading-text": "拼命打包中...",
          "element-loading-spinner": "el-icon-loading",
        },
      },
      [
        _c("div", { staticClass: "title" }, [_vm._v("APP云编译")]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c("div", { staticStyle: { color: "red" } }, [
          _vm._v("注意：编辑信息后，需点击启动才可生成新包!"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-top": "20px" } },
          [
            _c(
              "el-form",
              {
                staticClass: "demo-ruleForm",
                staticStyle: { "margin-top": "20px" },
                attrs: { "label-width": "120px" },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "both-label",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("\n            平台\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.changeType()
                          },
                        },
                        model: {
                          value: _vm.radio,
                          callback: function ($$v) {
                            _vm.radio = $$v
                          },
                          expression: "radio",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "0" } }, [
                          _vm._v("安卓"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("苹果"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v("鸿蒙"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "both-label",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _c("i", { staticStyle: { color: "red" } }),
                        _vm._v("\n            APP名称\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "my-item",
                      staticStyle: { width: "400px" },
                      attrs: { readonly: true },
                      model: {
                        value: _vm.appName,
                        callback: function ($$v) {
                          _vm.appName = $$v
                        },
                        expression: "appName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.radio * 1 !== 2
                  ? _c(
                      "el-form-item",
                      [
                        _c(
                          "div",
                          {
                            staticClass: "both-label",
                            attrs: { slot: "label" },
                            slot: "label",
                          },
                          [
                            _c("i", { staticStyle: { color: "red" } }),
                            _vm._v("\n            uniapp-appId\n          "),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "my-item",
                          staticStyle: { width: "400px" },
                          attrs: { readonly: true },
                          model: {
                            value: _vm.uni_appId,
                            callback: function ($$v) {
                              _vm.uni_appId = $$v
                            },
                            expression: "uni_appId",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.radio === "1"
                  ? _c(
                      "el-form-item",
                      [
                        _c(
                          "div",
                          {
                            staticClass: "both-label",
                            attrs: { slot: "label" },
                            slot: "label",
                          },
                          [
                            _c("i", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                            _vm._v("\n            适配ipad\n          "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.needIpad,
                              callback: function ($$v) {
                                _vm.needIpad = $$v
                              },
                              expression: "needIpad",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("不适配"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("适配"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticClass: "both-label",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("i", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                      _vm._v("\n            版本号\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                        width: "400px",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          max: 999,
                          "step-strictly": true,
                          controls: false,
                        },
                        model: {
                          value: _vm.one,
                          callback: function ($$v) {
                            _vm.one = $$v
                          },
                          expression: "one",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          width: "5px",
                          height: "5px",
                          "border-radius": "50%",
                          background: "#768089",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          max: 999,
                          "step-strictly": true,
                          controls: false,
                        },
                        model: {
                          value: _vm.two,
                          callback: function ($$v) {
                            _vm.two = $$v
                          },
                          expression: "two",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          width: "5px",
                          height: "5px",
                          "border-radius": "50%",
                          background: "#768089",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          max: 999,
                          "step-strictly": true,
                          controls: false,
                        },
                        model: {
                          value: _vm.three,
                          callback: function ($$v) {
                            _vm.three = $$v
                          },
                          expression: "three",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "font-size": "12px", color: "#969696" } },
                    [
                      _vm._v(
                        "\n            新打包时务必先对照下 下面的编译记录再填写版本号\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "both-label",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("\n            内建版本号\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.versionCodeStatus,
                          callback: function ($$v) {
                            _vm.versionCodeStatus = $$v
                          },
                          expression: "versionCodeStatus",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("保持"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("自增"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "12px", color: "#969696" },
                      },
                      [
                        _vm._v(
                          "\n            给平台识别的内部版本号，选择保持时为同版本更新，选择自增时打的是新版本。\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "both-label",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [_vm._v("备注")]
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        type: "textarea",
                        autosize: "",
                        placeholder: "请输入内容",
                      },
                      model: {
                        value: _vm.remark,
                        callback: function ($$v) {
                          _vm.remark = $$v
                        },
                        expression: "remark",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticStyle: { "margin-top": "40px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.save },
                      },
                      [_vm._v("启动")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-top": "0" } },
          [
            _c(
              "div",
              {
                staticClass: "title",
                staticStyle: { "margin-bottom": "24px" },
              },
              [
                _vm._v("\n        编译记录\n        "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  },
                  [_vm._v("刷新")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingTb,
                    expression: "loadingTb",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, border: "" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "buildVersion",
                    label: "版本号",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "osType", label: "编译平台", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.osType === 0
                                  ? "安卓"
                                  : scope.row.osType === 1
                                  ? "苹果"
                                  : "鸿蒙"
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "inVersion",
                    label: "内建版本号",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "status", label: "状态", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                class: [
                                  scope.row.status === 2 ? "success" : "",
                                  scope.row.status === 3 ? "error" : "",
                                ],
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.statusObj[scope.row.status]) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _vm._v("\n            状态\n            "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "打包预计需要20分钟",
                              placement: "top",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-question" })]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "remark", label: "备注", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyTime",
                    label: "申请时间",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "finishTime",
                    label: "完成时间",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "操作", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "fc" }, [
                            scope.row.status === 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Operation_button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.linkDown(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                下载链接\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Operation_button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.linkOver(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                结束任务\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }